function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MacaoFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2511",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2511)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#1C9975"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2511",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_2511)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0162 8.14032L10.7909 8.88003L11.0704 7.43657L10.05 6.35628L11.4317 6.29786L12.0162 4.95003L12.6007 6.29786H13.98L12.962 7.43657L13.2685 8.88003L12.0162 8.14032Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.53696 8.68837L7.77933 9.14574L7.95214 8.25322L7.32123 7.58526L8.17552 7.54914L8.53696 6.71574L8.89839 7.54914H9.75123L9.12177 8.25322L9.31127 9.14574L8.53696 8.68837Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.4357 8.68837L14.6781 9.14574L14.8509 8.25322L14.22 7.58526L15.0743 7.54914L15.4357 6.71574L15.7972 7.54914H16.65L16.0205 8.25322L16.21 9.14574L15.4357 8.68837Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.57486 10.208L5.96689 10.575L6.10556 9.85878L5.59927 9.32276L6.28482 9.29377L6.57486 8.625L6.8649 9.29377H7.54927L7.04415 9.85878L7.19622 10.575L6.57486 10.208Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.6706 10.208L17.0626 10.575L17.2013 9.85878L16.695 9.32276L17.3806 9.29377L17.6706 8.625L17.9606 9.29377H18.645L18.1399 9.85878L18.292 10.575L17.6706 10.208Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_2511",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "6",
        y: "7",
        width: "12",
        height: "13",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 19.5C15.3137 19.5 18 16.8137 18 13.5C18 10.1863 15.3137 7.5 12 7.5C8.68629 7.5 6 10.1863 6 13.5C6 16.8137 8.68629 19.5 12 19.5Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: "url(#mask2_621_2511)",
        children: /*#__PURE__*/_jsx("path", {
          d: "M9.46522 20.4588H6.53668V16.5155L9.45994 16.5155C10.4955 16.5009 11.2522 16.2052 11.757 15.6361L12.0086 15.3526L12.2894 15.6072C12.9637 16.2186 13.6372 16.5155 14.3186 16.5155H17.5468V20.4588H14.3186C13.5358 20.4588 12.7801 20.1643 12.0575 19.5878C11.4176 20.155 10.5486 20.4436 9.46522 20.4588Z",
          fill: "#F7FCFF"
        })
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.026 8.70587C12.026 8.70587 10.7444 9.97187 10.7444 11.7093C10.7444 12.0811 10.8031 12.4324 10.8954 12.7549C10.4825 11.8398 10.4539 10.8475 10.8102 9.76509L10.3252 9.60541C9.96271 10.7065 9.96114 11.7417 10.321 12.7011C9.57654 12.2526 8.72003 11.9512 7.84089 11.854L7.78478 12.3616C8.55314 12.4465 9.30308 12.7027 9.9615 13.082C9.79892 13.0164 9.62844 12.9594 9.45058 12.914C7.82837 12.5 6.23685 13.0871 6.23685 13.0871C6.23685 13.0871 7.15491 15.1467 8.93308 15.4505C9.02167 15.4656 9.10925 15.4774 9.1957 15.4861L9.18245 15.4861C8.33465 15.4861 7.54625 15.1395 6.80797 14.4353L6.45552 14.8048C7.28477 15.5958 8.19683 15.9968 9.18245 15.9968C10.1464 15.9968 11.0416 15.6133 11.8596 14.8565C11.9909 14.7772 12.0677 14.7205 12.0799 14.7113L12.1121 14.7387C12.0952 14.7676 12.0868 14.7834 12.0868 14.7834C12.0868 14.7834 12.1674 14.8322 12.3129 14.901C13.1205 15.527 14.1311 15.9968 14.9306 15.9968C15.9162 15.9968 16.8283 15.5958 17.6575 14.8048L17.3051 14.4353C16.5668 15.1395 15.7784 15.4861 14.9306 15.4861C14.6209 15.4861 14.3174 15.4364 14.0197 15.3362C14.4365 15.3587 14.8958 15.3211 15.3712 15.1758C17.1228 14.6403 17.8529 13.0205 17.8529 13.0205C17.8529 13.0205 16.9209 12.5177 15.7372 12.512C16.0024 12.4436 16.2792 12.3935 16.5678 12.3616L16.5117 11.854C15.4015 11.9768 14.441 12.3515 13.6353 12.9767C14.1064 11.9409 14.1429 10.8127 13.7454 9.60541L13.2604 9.76509C13.5852 10.7517 13.5901 11.6634 13.2758 12.5101C13.3296 12.2597 13.3615 11.9921 13.3615 11.7093C13.3615 9.8777 12.026 8.70587 12.026 8.70587ZM12.5898 14.0666L12.5708 14.094L12.594 14.0663L12.5898 14.0666ZM11.3511 13.947L11.4013 13.9008C11.4469 13.9766 11.4925 14.048 11.537 14.1147C11.4793 14.0603 11.4173 14.0041 11.3511 13.947Z",
        fill: "#F7FCFF"
      })]
    })]
  })]
}));
//# sourceMappingURL=Macao.js.map